export default "__VITE_ASSET__CLyw2CV6__"